var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultFloorplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 152,
    viewBox: "0 0 150 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 43.5233H42.875V68.8983H68.25V43.5233Z",
    stroke: "#DDDEE0",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.125 43.5233H82.75V68.8983H108.125V43.5233Z",
    stroke: "#DDDEE0",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.125 83.3983H82.75V108.773H108.125V83.3983Z",
    stroke: "#DDDEE0",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 83.3983H42.875V108.773H68.25V83.3983Z",
    stroke: "#DDDEE0",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.491 148H102.007C101.124 148 100.406 147.282 100.406 146.399V127.27C100.406 126.387 101.124 125.669 102.007 125.669H110.491C111.374 125.669 112.092 126.387 112.092 127.27V146.399C112.092 147.282 111.374 148 110.491 148ZM103.608 144.798H108.891V128.871H103.608V144.798Z",
    fill: "#359EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.25 120.149C93.9818 120.149 84 110.167 84 97.8985C84 85.6303 93.9821 75.6483 106.25 75.6483C118.518 75.6483 128.5 85.6303 128.5 97.8985C128.5 110.166 118.518 120.149 106.25 120.149ZM106.25 78.8476C95.7456 78.8476 87.2016 87.3926 87.2016 97.8962C87.2016 108.401 95.7467 116.945 106.25 116.945C116.755 116.945 125.299 108.4 125.299 97.8962C125.299 87.3926 116.751 78.8476 106.25 78.8476Z",
    fill: "#359EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.246 113.421C97.6849 113.421 90.7188 106.455 90.7188 97.8942C90.7188 89.3332 97.6849 82.367 106.246 82.367C114.807 82.367 121.773 89.3332 121.773 97.8942C121.773 106.455 114.807 113.421 106.246 113.421ZM106.246 85.5725C99.4495 85.5725 93.9204 91.1016 93.9204 97.898C93.9204 104.694 99.4495 110.224 106.246 110.224C113.042 110.224 118.571 104.694 118.571 97.898C118.568 91.1016 113.039 85.5725 106.246 85.5725Z",
    fill: "#359EFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.249 128.872C105.366 128.872 104.648 128.155 104.648 127.272V118.548C104.648 117.664 105.366 116.947 106.249 116.947C107.133 116.947 107.85 117.664 107.85 118.548V127.272C107.85 128.155 107.133 128.872 106.249 128.872Z",
    fill: "#359EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFloorplan);
export default __webpack_public_path__ + "static/media/defaultFloorplan.f132fce2073220cb953b22b5492f5551.svg";
export { ForwardRef as ReactComponent };